export const route = {
    patterns: {
        onboarding: '/onboarding',
    },
    searchParams: { manualOnboarding: 'manualOnboarding', onboardingStep: 'onboardingStep', uploadCv: 'uploadCv' },
};
